// extracted by mini-css-extract-plugin
export var fallbackHint = "Pdf-module--fallbackHint--4eda3";
export var pdfError = "Pdf-module--pdfError--c2f7a";
export var pdfLoading = "Pdf-module--pdfLoading--789a1";
export var pdfPage = "Pdf-module--pdfPage--621d3";
export var pdfViewerContainer = "Pdf-module--pdfViewerContainer--55745";
export var pdfWrapper = "Pdf-module--pdfWrapper--9797d";
export var wrapper = "Pdf-module--wrapper--37917";